import { MoveStruct } from "../../../utils/index.mjs";
import { bcs } from "@safecoin/safe/bcs";
const TypeName = new MoveStruct({
	name: `0x0000000000000000000000000000000000000000000000000000000000000001::type_name::TypeName`,
	fields: { name: bcs.string() }
});
//#endregion
export { TypeName };

//# sourceMappingURL=type_name.mjs.map